import axios from 'axios'
import qs from 'query-string';

/* Config */
import appConfig from '../../appConfig'
import {getBrowserCookie} from '../../../client/common/persistence/browserCookieUtils';
import {HBUS_ANONYMOUS_ID_COOKIE_NAME, TENANT, USER_INFO_JWT_TOKEN_COOKIE_NAME} from '../account/accountConstants';


let jwt = null;
let anonymousId = null;
let tenant = null;

// Todo Replace this function with a dispatch request
const hydraHomeLazyRequest = (params) => {

  jwt ??= getBrowserCookie(USER_INFO_JWT_TOKEN_COOKIE_NAME) || null;
  anonymousId ??= getBrowserCookie(HBUS_ANONYMOUS_ID_COOKIE_NAME) || null;
  tenant ??= getBrowserCookie(TENANT) || null;

  const {componentKey, platform, userInfo, ...queryParams} = params;
  queryParams.tenant = tenant;

  const platformType = platform ? platform : 'web'

  const parsedUserInfo = userInfo ? JSON.parse(userInfo) : null;
  const lazyreq = axios.get(
    `${appConfig.hydraHomepageUrl}/api/v1/home/${platformType}/view/${
      params?.viewId ? params.viewId : platformType === 'web' ? 'web_homepage' : 'mweb_homepage'
    }/${componentKey}?${qs.stringify(queryParams)}`,
    {
      ...params,
      headers: {
        'X-Platform': 'web',
        'X-Language': 'tr',
        'X-Anonymous-Id': anonymousId || '',
        'X-User-Id': parsedUserInfo?.uid || '',
        ...jwt && {'X-Jwt': jwt ?? null},
      },
    }
  )
  return lazyreq
}

export default hydraHomeLazyRequest
